module.exports = __webpack_public_path__ + "static/background-da5031c63daa9268604634dff155da59.mp4";